import React from 'react';
import { X } from 'react-feather';
import PropTypes from 'prop-types';
import { Modal, Button, ButtonGroup } from 'ui';

const RemoveBadgeModal = ({
  shown,
  closeModal,
  removeBadge,
  isRemoveBadgeLoading,
}) => {
  return (
    <Modal
      shown={shown}
      canClickAway={false}
      onDismiss={closeModal}
      className="w-488"
    >
      <div className="d-f fd-r jc-sb ai-c c-brand-gray-darkest bg-gray-lightest py-16 px-16">
        <span className="fw-b">
          {t('certifications.remove_badge_modal.title')}
        </span>
        <X size={16} onClick={closeModal} className="h-cr-p" />
      </div>
      <div className="px-16 d-f fd-c ff-ss">
        <span className="fw-b py-16 c-brand-gray-darkest">
          {t('certifications.remove_badge_modal.undo_warning')}
        </span>
        <span className="pb-16 c-brand-gray-darkest">
          {t('certifications.remove_badge_modal.description')}
        </span>
      </div>
      <ButtonGroup alignEnd className="py-16 pr-16">
        <Button
          disabled={isRemoveBadgeLoading}
          onClick={closeModal}
          className="w-125"
        >
          {t('certifications.remove_badge_modal.cancel')}
        </Button>
        <Button
          loading={isRemoveBadgeLoading}
          primary
          onClick={removeBadge}
          className="w-125"
        >
          {t('certifications.remove_badge_modal.delete')}
        </Button>
      </ButtonGroup>
    </Modal>
  );
};

RemoveBadgeModal.propTypes = {
  shown: PropTypes.bool,
  closeModal: PropTypes.func,
  removeBadge: PropTypes.func,
  isRemoveBadgeLoading: PropTypes.bool,
};

export default RemoveBadgeModal;
